import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const LINES = [
  { text: "You don't need another architect.", italic: false },
  { text: "You need a proven system.", italic: false },
  { text: "The Luxury Legacy Villa Formula.", italic: true },
];

function Line({ text, italic, range, progress }) {
  const opacity = useTransform(progress, range, [0.12, 1]);
  const y = useTransform(progress, range, [40, 0]);
  return (
    <motion.p
      style={{ opacity, y }}
      className={`font-serif text-4xl leading-[1.1] sm:text-6xl lg:text-7xl ${
        italic ? "italic text-champagne" : "text-warm"
      }`}
    >
      {text}
    </motion.p>
  );
}

export default function ManifestoReveal() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"],
  });

  const ranges = [
    [0.05, 0.3],
    [0.35, 0.6],
    [0.65, 0.9],
  ];

  return (
    <section ref={ref} data-testid="manifesto-section" className="relative h-[280vh] bg-charcoal">
      <div className="sticky top-0 flex h-screen items-center">
        <div className="mx-auto w-full max-w-[1600px] px-6 md:px-12">
          <div className="space-y-8 md:space-y-12">
            {LINES.map((l, i) => (
              <Line key={i} {...l} range={ranges[i]} progress={scrollYProgress} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
